import React from 'react';
import { TrophyIcon, SearchIcon, GiftIcon, StarIcon } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <TrophyIcon className="w-5 h-5 text-silver" data-id="element-308" data-mp="3lufd51vd3uqk" />,
    text: '+200 docentes'
  }, {
    icon: <SearchIcon className="w-5 h-5 text-silver" data-id="element-309" data-mp="36xeml1owq5to" />,
    text: '6 Tomos completos'
  }, {
    icon: <GiftIcon className="w-5 h-5 text-silver" data-id="element-310" data-mp="3buwy8zub6z5d" />,
    text: '4 Bonos incluidos'
  }, {
    icon: <StarIcon className="w-5 h-5 text-silver fill-silver" data-id="element-311" data-mp="3gy4m4ut7pv1" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-navy-900 border-y border-silver/20 py-6" data-id="element-312" data-mp="3puftwt5xoi0s">
      <div className="container mx-auto px-4" data-id="element-313" data-mp="3ptwlc326b5zf">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-314" data-mp="3ut99qs8p0l44">
          {stats.map(stat => <div key={stat.text} className="flex items-center gap-2 font-medium text-silver-light" data-id="element-315" data-mp="mcehe6piuj4a">
              {stat.icon}
              <span data-id="element-316" data-mp="1uawbjg75vp2j">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}